import { useContext, useEffect } from 'react'
import styled from 'styled-components'

import BackIcon from '../icons/BackIcon'
import CrosshairsIcon from '../icons/CrosshairsIcon'
import DoubleBackIcon from '../icons/DoubleBackIcon'
import IconContainer from '../icons/IconContainer'

import Container from '../basic-components/Container'
import Content from '../basic-components/Content'
import { Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'

import MapContext from '../context/MapContext'
import QueryContext from '../context/QueryContext'

import { getParcelDetailByAddress, getParcelDetailById } from '../api/server-api'

const Table = styled.div`
  display: table;
  padding: 1em;
`
const TableRow = styled.div`
  display: table-row;
`
const TableCell = styled.div`
  display: table-cell;
  text-align: left;
`

export default function ParcelDetailPage({
  searchType,
  parcelSearchParams,
  gotoMap,
  onBackClick,
  onDoubleBackClick,
  onCrosshairsClick,
}) {

  const { showResultOnMap } = useContext(MapContext);
  const { queryData, setQueryData } = useContext(QueryContext);

  const crosshairsClickHandler = () => {
    onCrosshairsClick();
    gotoMap(true);
  }

  useEffect(() => {
    const getData = async () => {
      let data;
      switch (searchType) {
        case 'Search by Address':
          data = await getParcelDetailByAddress(parcelSearchParams);
          break;
        default:
          //console.log(parcelSearchParams);
          data = await getParcelDetailById(parcelSearchParams.parcelId);
      }
      //console.log(data);

      setQueryData(data);
      if (data.attributes.rightlow) {
        // got street segment and interpolated point
        // go straight to map
        showResultOnMap(data);
        gotoMap(false);
      }
    }

    //console.log(searchType, parcelSearchParams);
    getData(searchType, parcelSearchParams);
  },[searchType, parcelSearchParams, setQueryData, showResultOnMap, gotoMap]);

  //console.log(queryData);
  return (
    <Container>
      <Header>
        <IconContainer>
          <DoubleBackIcon onClick={onDoubleBackClick}/>
          <BackIcon onClick={onBackClick}/>
        </IconContainer>
        <HeaderTitle><strong>Search Detail</strong></HeaderTitle>
        <IconContainer justify="right">
          <CrosshairsIcon onClick={crosshairsClickHandler} />
        </IconContainer>
      </Header>
      <Content>
        <Table>
        {!queryData ? null : (
          Object.keys(queryData.attributes).map((key) => {
            return (
              <TableRow key={key}>
                <TableCell>
                  {key}:
                </TableCell>
                <div style={{display: 'table-cell', minWidth: '1em'}} />
                <TableCell>
                {queryData.attributes[key]}
                </TableCell>
              </TableRow>
            );
          })
        )}
        </Table>
      </Content>
    </Container>
  );
}
